<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="商品出库"></el-page-header>
        <el-form label-position="right" :model="item" label-width="auto">
            <el-form-item label="商品图片" prop="goodsImage">
                <img width="140" src="https://oss.xm0592.com/user/2021/07/07/29a6f20486ef4ddab175efde66cbe648.jpg"
                     alt="">
            </el-form-item>
            <el-form-item label="商品规格" prop="goodsImage">
                <el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
                          :data="tableColumnList.tableBodyList" border tooltip-effect="dark">
                    <el-table-column :label="item" :property="item" v-for="item in tableColumnList.tableHeaderList"
                                     :key="item" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row[scope.column.property] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="出库数量(件)">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.number"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>

			<el-form-item>
                    <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
</el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                        >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
             </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                id:this.$route.query.id,
                dialogVisible: false,
                goodsImage: [],
                options: [],
                tableColumnList: {
                    tableHeaderList: [
                        '颜色', '尺寸', '重量',
                    ],
                    tableBodyList: [{
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '1'
                    }, {
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '2'
                    }, {
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '3'
                    }, {
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '4'
                    }, {
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '5'
                    }, {
                        尺寸: "X",
                        重量: "轻",
                        颜色: "红",
                        number: '6'
                    }]
                }
            }
        },
        created() {
            // this.loadData()
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business/list', {}).then(res => {
                    res.data.records.forEach((item) => {
                        this.options.push(item)
                    })
                }).then(res => {
                    if (this.id) {
                        return this.axios.post('/admin/business/store/detail', {
                            id: this.id
                        })
                    }
                }).then(res => {
                    this.isLoad = !this.isLoad
                    if (res) {
                        // item是基础信息
                        this.item = res.data

                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            // 提交
            submit() {
                return;
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad

                let url = ''
                if (this.id) {
                    url = '/admin/business/store/update'
                    this.item.id = this.id
                } else {
                    url = '/admin/business/store/add'
                }
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>